export const capitalize = text => {
    if (!text) {
        return text;
    }
    return text[0].toUpperCase() + text.slice(1)
};



// WEBPACK FOOTER //
// ./src/utils/text.js